export interface User {
  id: string;
  email: string;
  name: string;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: User;
}

export interface Dog {
  id: string;
  userId: string;
  name: string;
  breed: string;
  registeredName: string | null;
  akcRegistrationNumber: string | null;
  birthDate: string | null;
  sex: string | null;
  heightInches: string | null;
  handicap: string | null;
  historicalPoints: string | null;
  photo: string | null;
  photoFocusY: number | null;
  social?: {
    instagram?: string;
    facebook?: string;
    tiktok?: string;
    x?: string;
    youtube?: string;
  } | null;
  createdAt: string;
  updatedAt: string;
}

export interface Run {
  id: string;
  dogId: string;
  eventId: string | null;
  date: string;
  runNumber: number;
  timeSeconds: string;
  speedMph: string;
  points: string;
  cumulativePoints: string;
  titleEarned: string | null;
  notes: string | null;
  location: string | null;
  eventName: string | null;
  lureOperator: string | null;
  photos: string[];
  createdAt: string;
  updatedAt: string;
}

export interface DogStats {
  totalRuns: number;
  totalPoints: number;
  averageSpeed: number;
  bestThreeAvgSpeed: number;
  personalBestSpeed: number;
  personalBestTime: number;
  personalBestPoints: number;
  currentTitle: string | null;
  nextTitle: string | null;
  pointsToNextTitle: number;
  run1AvgSpeed: number;
  run2AvgSpeed: number;
  run1Count: number;
  run2Count: number;
  /** Avg points from last 5 logged runs (excludes historical AKC backfill) — used for runs-to-next-title projections. */
  avgPointsPerRun: number;
}

export interface Event {
  id: string;
  akcEventId: string;
  name: string;
  club: string | null;
  date: string;
  closingDate: string | null;
  address: string | null;
  city: string | null;
  state: string | null;
  zip: string | null;
  latitude: number | null;
  longitude: number | null;
  eventUrl: string | null;
  entryUrl: string | null;
  openingDate: string | null;
  openingTime: string | null;
  closingTime: string | null;
  timeZone: string | null;
  entryFee: string | null;
  eventSetting: string | null;
  eligibleBreeds: string | null;
  eventChair: string | null;
  eventChairContact: string | null;
  secretary: string | null;
  secretaryContact: string | null;
  clubWebsite: string | null;
  premiumListUrl: string | null;
  lureOperator: string | null;
  eventPhotographer: string | null;
  eventPhotographerEmail: string | null;
  eventPhotographerUrl: string | null;
  eventPhotographers: Array<{ name?: string; email?: string; url?: string }> | null;
  clubLogoUrl: string | null;
  clubLogoStyle: string | null;
  clubGallery: { photos?: string[]; widePhotos?: string[]; videos?: string[]; videoPosters?: string[]; photoCredit?: string } | null;
  clubRibbonPreviewUrl: string | null;
  clubRibbonPreviews: string[] | null;
  dayOfRunsFee: string | null;
  isFeatured: boolean;
  eventWhatSetsApart: string | null;
  clubRaffle: {
    title?: string;
    description?: string;
    drawingDate?: string;
    url?: string;
    urlLabel?: string;
    photos?: string[];
  } | null;
  // Only present on zip-based searches — miles from the searched zip's center
  distance_miles?: number | null;
}

export interface BreedRanking {
  id: string;
  breed: string;
  year: string;
  rank: number;
  dogName: string;
  owner: string | null;
  speed: number | null;
  points: number | null;
  runsCompleted: number | null;
  publicSlug?: string | null;
  photo?: string | null;
  callName?: string | null;
  photoFocusY?: number | null;
}
